import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Store} from '@ngxs/store';
import {SessionState} from 'src/app/shared/state/session-state';
import {NavComponent} from './nav/nav.component';
import {RouterOutlet} from '@angular/router';
import {LoadIndicatorComponent, ToastComponent} from '@ratespecial/core';

@Component({
  selector: 'app-primary-layout',
  templateUrl: './primary-layout.component.html',
  styleUrls: ['./primary-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavComponent, RouterOutlet, LoadIndicatorComponent, ToastComponent],
})
export class PrimaryLayoutComponent {
  private store = inject(Store);

  readonly isWidescreen = this.store.selectSignal(SessionState.isWidescreen);
}
